/* eslint-disable */
import { disableScrollForInputDrawer, enableScrollForInputDrawer } from '~/js/utils/dom';

export const quickBuyModal = () => ({
  isVisible: false,
  body: document.body,
  productHtml: '',
  isLoading: false,
  modalLoaded: false,
  dialog: null,

  set_dialog(dialog) {
    this.dialog = dialog;
  },

  show() {
    if (this.isVisible) return;
    this.dialog.showModal();
    this.body.classList.add('scroll-lock');
    this.isVisible = true;
    setTimeout(() => {
      this.modalLoaded = true;
    }, 10);
    window.isMobile && disableScrollForInputDrawer();
  },

  hide() {
    if (!this.isVisible) return;
    this.body.classList.remove('scroll-lock');
    this.isVisible = false;
    this.dialog.close();
    this.modalLoaded = false;
    this.productHtml = '';
    window.isMobile && enableScrollForInputDrawer();
  },

  loadModal: async function (productHandle, event = null) {
    if (!this.dialog) {
      console.error('Quick Buy Dialog not set');
      alert("Sorry, we couldn't load the Quick Buy feature");
      return;
    }

    if (this.isLoading) return;
    this.isLoading = true;

    let triggerButton = null;
    let triggerButtonText = '';
    if (event?.target) {
      triggerButton = event.target;
      triggerButton.classList.add('loading-indicator');
    }

    try {
      const res = await fetch(`/products/${productHandle}?section_id=quick-buy-product`);

      if (!res.ok) {
        throw new Error(`Fetch of quickBuyModal failed`);
      }

      const parsedRes = await res.text(); // Get the complete HTML response

      this.productHtml = parsedRes;
      this.show();
    } catch (err) {
      console.error(err.message);
      alert("Sorry, we couldn't load the Quick Buy feature");
    } finally {
      if (triggerButton) triggerButton.classList.remove('loading-indicator');
      this.isLoading = false;
    }
  },
});
